import React, { useMemo } from "react";
import {
  Field,
  ErrorMessage,
  FastField,
  FormikContextType,
  FieldInputProps,
  FieldMetaProps,
} from "formik";
import TextError from "./TextError";
import { FormInputLabel } from "./FormInputLabel";
import { classNames } from "primereact/utils";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";
import * as Yup from "yup";

export interface FormikInputTextPros extends InputTextareaProps {
  label: string;
  name: string;
  showLabel?: boolean;
  validationSchema?: Yup.ObjectSchema<any, Yup.AnyObject, any, "">;
  isIndependent?: boolean;
}

function FormikInputTextarea({
  label,
  name,
  validationSchema,
  isIndependent = false,
  showLabel = true,
  rows,
  ...rest
}: FormikInputTextPros) {
  const Component = useMemo(() => {
    return isIndependent ? FastField : Field;
  }, [isIndependent]);

  return (
    <>
      {showLabel && (
        <FormInputLabel
          nameFor={name}
          validationSchema={validationSchema}
        >
          {label}
        </FormInputLabel>
      )}
      <Component name={name}>
        {({
          form,
          field,
          meta,
        }: {
          form: FormikContextType<any>;
          field: FieldInputProps<string>;
          meta: FieldMetaProps<string>;
        }) => {
          return (
            <InputTextarea
              id={name}
              className={classNames({
                "w-full": true,
                "p-invalid": meta.error && meta.touched,
              })}
              style={{ resize: "none" }}
              placeholder={label}
              value={field.value}
              onBlur={(e) => form.setFieldTouched(name, true)}
              onChange={(e) => {
                form.setFieldValue(name, e.target.value);
              }}
              rows={rows}
              {...rest}
            />
          );
        }}
      </Component>
      <ErrorMessage
        component={TextError}
        name={name}
      />
    </>
  );
}

export default FormikInputTextarea;
